// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssessmentBlock_mainLayout__JY0nc {
  display: grid;
  grid-template-areas:
    "header action"
    "body body"
    "error error";
  width: 100%;
  row-gap: 10px;
  height: 100%;
}

.AssessmentBlock_mainLayoutWithSession__sWKy0 {
  display: grid;
  grid-template-areas:
    "task task"
    "session session"
    "header action"
    "body body"
    "error error";
  width: 100%;
  row-gap: 10px;
  height: 100%;
}

.AssessmentBlock_mainLayoutHeader__-2St1 {
  grid-area: header;
}

.AssessmentBlock_mainLayoutAction__YRyKV {
  grid-area: action;
  display: flex;
  flex-direction: row-reverse;
}

.AssessmentBlock_mainLayoutBody__6gTNa {
  grid-area: body;
}

.AssessmentBlock_mainLayoutTask__gSKXM {
  grid-area: task;
}

.AssessmentBlock_mainLayoutSession__oA3\\+l {
  grid-area: session;
}

.AssessmentBlock_mainLayoutError__1UfZR {
  grid-area: error;
}

.AssessmentBlock_mainActionButton__gw\\+82 {
  height: fit-content;
  margin-top: -5px;
}

.AssessmentBlock_mainHeaderError__Ytt93 {
  color: red;
  font-size: medium;
}

.AssessmentBlock_columnRequired__NLHGw {
  width: 100%;
  color: var(--branded-purple);
}

.AssessmentBlock_addAssessmentDialog__KxCiE {
  width: 600px;
  max-width: calc(100vw - 30px);
}

.AssessmentBlock_addAssessmentLayout__pc0C6 {
  display: grid;
  grid-template-areas:
    "search"
    "body"
    "button";
  width: 100%;
  row-gap: 10px;
  height: 100%;
}

.AssessmentBlock_addAssessmentLayoutSearch__dHlMm {
  grid-area: search;
}

.AssessmentBlock_addAssessmentLayoutBody__3OzoH {
  grid-area: body;
}

.AssessmentBlock_addAssessmentLayoutButton__p9syf {
  grid-area: button;
  width: 100%;
}

.AssessmentBlock_addAssessmentSearch__a-V9L {
  width: 100%;
}

.AssessmentBlock_hideTableHeader__HqIPG .p-datatable-thead {
  display: none;
}

.AssessmentBlock_addAssessmentButton__lvIDX {
  float: right;
  margin-right: 0px;
}

.AssessmentBlock_blockActionButtons__FDG3X {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.AssessmentBlock_blockActionButtons__FDG3X .saveBtn {
  border-radius: 28px;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 16px;
  margin-right: 10px;
  background-color: var(--branded-purple);
}

.AssessmentBlock_blockActionButtons__FDG3X .saveBtn:disabled {
  background-color: #cccccc;
  color: #666666;
  opacity: 0.65;
  border: 1px solid #883cae;
}

.AssessmentBlock_blockActionButtons__FDG3X .editBtn {
  border-radius: 28px;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 16px;
  margin-right: 10px;
  background-color: var(--branded-purple);
  color: white;
}

.AssessmentBlock_actionColumn__fZicW {
  width: 140px;
}

.AssessmentBlock_title__Pb5MR {
  font-weight: 600;
  font-size: 18px;
  line-height: 2rem;
}

.AssessmentBlock_sessionLayout__I68-5 {
  display: grid;
  grid-template-areas:
    "title title"
    "date location";
  width: 100%;
  gap: 10px;
  height: 100%;
  padding-right: 10px;
}

.AssessmentBlock_sessionLayoutTitle__DqF2R {
  grid-area: title;
}

.AssessmentBlock_sessionLayoutDate__wEzrL {
  grid-area: date;
}

.AssessmentBlock_sessionLayoutLocation__uial8 {
  grid-area: location;
}

.AssessmentBlock_sessionDate__VvNz\\+ {
  width: 100%;
  margin-top: 6px;
}

.AssessmentBlock_sessionDropDown__4rdkE {
  width: 100%;
  margin-bottom: 10px;
}

.AssessmentBlock_sessionDropdownContainer__XMJdh {
  display: flex;
}

.AssessmentBlock_mainLayoutWithTask__c3I28 {
  display: grid;
  grid-template-areas:
    "title title"
    "name staff"
    "dueDate completedDate";
  grid-template-columns: 50% 50%;
  width: 100%;
  row-gap: 10px;
  height: 100%;
}

.AssessmentBlock_mainLayoutWithTaskTitle__iaG4f {
  grid-area: title;
}

.AssessmentBlock_mainLayoutWithTaskName__lTci8 {
  grid-area: name;
}

.AssessmentBlock_mainLayoutWithTaskStaff__N8\\+rr {
  grid-area: staff;
}

.AssessmentBlock_mainLayoutWithDue__yRrEd {
  grid-area: dueDate;
}

.AssessmentBlock_mainLayoutWithTaskComplete__obYgn {
  grid-area: completedDate;
}

.AssessmentBlock_taskTitle__wgneV {
  font-weight: 500;
  font-size: 0.95rem;
}

.AssessmentBlock_taskValue__8VMqY {
  font-weight: 400;
  font-size: 0.95rem;
}

.AssessmentBlock_assessmentInformationPanel__UyDzQ {
  background-color: #eedef6;
  border-color: #eedef6;
  margin-bottom: 10px;
  border-radius: 10px;
}

.AssessmentBlock_assessmentInformationPanel__UyDzQ .p-panel-header {
  background-color: #eedef6;
  padding: 0px 5px !important;
}

.AssessmentBlock_assessmentInformationPanel__UyDzQ .p-panel-content {
  padding: 1px;
  background-color: #eedef6;
  padding: 10px;
  border-radius: 10px;
}

.AssessmentBlock_assessmentInformation__q4hs9 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/assessments/AssessmentBlock.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb;;;iBAGe;EACf,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb;;;;;iBAKe;EACf,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb;;;YAGU;EACV,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb;;mBAEiB;EACjB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb;;;2BAGyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".mainLayout {\n  display: grid;\n  grid-template-areas:\n    \"header action\"\n    \"body body\"\n    \"error error\";\n  width: 100%;\n  row-gap: 10px;\n  height: 100%;\n}\n\n.mainLayoutWithSession {\n  display: grid;\n  grid-template-areas:\n    \"task task\"\n    \"session session\"\n    \"header action\"\n    \"body body\"\n    \"error error\";\n  width: 100%;\n  row-gap: 10px;\n  height: 100%;\n}\n\n.mainLayoutHeader {\n  grid-area: header;\n}\n\n.mainLayoutAction {\n  grid-area: action;\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.mainLayoutBody {\n  grid-area: body;\n}\n\n.mainLayoutTask {\n  grid-area: task;\n}\n\n.mainLayoutSession {\n  grid-area: session;\n}\n\n.mainLayoutError {\n  grid-area: error;\n}\n\n.mainActionButton {\n  height: fit-content;\n  margin-top: -5px;\n}\n\n.mainHeaderError {\n  color: red;\n  font-size: medium;\n}\n\n.columnRequired {\n  width: 100%;\n  color: var(--branded-purple);\n}\n\n.addAssessmentDialog {\n  width: 600px;\n  max-width: calc(100vw - 30px);\n}\n\n.addAssessmentLayout {\n  display: grid;\n  grid-template-areas:\n    \"search\"\n    \"body\"\n    \"button\";\n  width: 100%;\n  row-gap: 10px;\n  height: 100%;\n}\n\n.addAssessmentLayoutSearch {\n  grid-area: search;\n}\n\n.addAssessmentLayoutBody {\n  grid-area: body;\n}\n\n.addAssessmentLayoutButton {\n  grid-area: button;\n  width: 100%;\n}\n\n.addAssessmentSearch {\n  width: 100%;\n}\n\n.hideTableHeader :global(.p-datatable-thead) {\n  display: none;\n}\n\n.addAssessmentButton {\n  float: right;\n  margin-right: 0px;\n}\n\n.blockActionButtons {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.blockActionButtons :global(.saveBtn) {\n  border-radius: 28px;\n  padding: 8px 16px;\n  font-weight: 600;\n  font-size: 16px;\n  margin-right: 10px;\n  background-color: var(--branded-purple);\n}\n\n.blockActionButtons :global(.saveBtn:disabled) {\n  background-color: #cccccc;\n  color: #666666;\n  opacity: 0.65;\n  border: 1px solid #883cae;\n}\n\n.blockActionButtons :global(.editBtn) {\n  border-radius: 28px;\n  padding: 8px 16px;\n  font-weight: 600;\n  font-size: 16px;\n  margin-right: 10px;\n  background-color: var(--branded-purple);\n  color: white;\n}\n\n.actionColumn {\n  width: 140px;\n}\n\n.title {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 2rem;\n}\n\n.sessionLayout {\n  display: grid;\n  grid-template-areas:\n    \"title title\"\n    \"date location\";\n  width: 100%;\n  gap: 10px;\n  height: 100%;\n  padding-right: 10px;\n}\n\n.sessionLayoutTitle {\n  grid-area: title;\n}\n\n.sessionLayoutDate {\n  grid-area: date;\n}\n\n.sessionLayoutLocation {\n  grid-area: location;\n}\n\n.sessionDate {\n  width: 100%;\n  margin-top: 6px;\n}\n\n.sessionDropDown {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.sessionDropdownContainer {\n  display: flex;\n}\n\n.mainLayoutWithTask {\n  display: grid;\n  grid-template-areas:\n    \"title title\"\n    \"name staff\"\n    \"dueDate completedDate\";\n  grid-template-columns: 50% 50%;\n  width: 100%;\n  row-gap: 10px;\n  height: 100%;\n}\n\n.mainLayoutWithTaskTitle {\n  grid-area: title;\n}\n\n.mainLayoutWithTaskName {\n  grid-area: name;\n}\n\n.mainLayoutWithTaskStaff {\n  grid-area: staff;\n}\n\n.mainLayoutWithDue {\n  grid-area: dueDate;\n}\n\n.mainLayoutWithTaskComplete {\n  grid-area: completedDate;\n}\n\n.taskTitle {\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.taskValue {\n  font-weight: 400;\n  font-size: 0.95rem;\n}\n\n.assessmentInformationPanel {\n  background-color: #eedef6;\n  border-color: #eedef6;\n  margin-bottom: 10px;\n  border-radius: 10px;\n}\n\n.assessmentInformationPanel :global(.p-panel-header) {\n  background-color: #eedef6;\n  padding: 0px 5px !important;\n}\n\n.assessmentInformationPanel :global(.p-panel-content) {\n  padding: 1px;\n  background-color: #eedef6;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.assessmentInformation {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainLayout": `AssessmentBlock_mainLayout__JY0nc`,
	"mainLayoutWithSession": `AssessmentBlock_mainLayoutWithSession__sWKy0`,
	"mainLayoutHeader": `AssessmentBlock_mainLayoutHeader__-2St1`,
	"mainLayoutAction": `AssessmentBlock_mainLayoutAction__YRyKV`,
	"mainLayoutBody": `AssessmentBlock_mainLayoutBody__6gTNa`,
	"mainLayoutTask": `AssessmentBlock_mainLayoutTask__gSKXM`,
	"mainLayoutSession": `AssessmentBlock_mainLayoutSession__oA3+l`,
	"mainLayoutError": `AssessmentBlock_mainLayoutError__1UfZR`,
	"mainActionButton": `AssessmentBlock_mainActionButton__gw+82`,
	"mainHeaderError": `AssessmentBlock_mainHeaderError__Ytt93`,
	"columnRequired": `AssessmentBlock_columnRequired__NLHGw`,
	"addAssessmentDialog": `AssessmentBlock_addAssessmentDialog__KxCiE`,
	"addAssessmentLayout": `AssessmentBlock_addAssessmentLayout__pc0C6`,
	"addAssessmentLayoutSearch": `AssessmentBlock_addAssessmentLayoutSearch__dHlMm`,
	"addAssessmentLayoutBody": `AssessmentBlock_addAssessmentLayoutBody__3OzoH`,
	"addAssessmentLayoutButton": `AssessmentBlock_addAssessmentLayoutButton__p9syf`,
	"addAssessmentSearch": `AssessmentBlock_addAssessmentSearch__a-V9L`,
	"hideTableHeader": `AssessmentBlock_hideTableHeader__HqIPG`,
	"addAssessmentButton": `AssessmentBlock_addAssessmentButton__lvIDX`,
	"blockActionButtons": `AssessmentBlock_blockActionButtons__FDG3X`,
	"actionColumn": `AssessmentBlock_actionColumn__fZicW`,
	"title": `AssessmentBlock_title__Pb5MR`,
	"sessionLayout": `AssessmentBlock_sessionLayout__I68-5`,
	"sessionLayoutTitle": `AssessmentBlock_sessionLayoutTitle__DqF2R`,
	"sessionLayoutDate": `AssessmentBlock_sessionLayoutDate__wEzrL`,
	"sessionLayoutLocation": `AssessmentBlock_sessionLayoutLocation__uial8`,
	"sessionDate": `AssessmentBlock_sessionDate__VvNz+`,
	"sessionDropDown": `AssessmentBlock_sessionDropDown__4rdkE`,
	"sessionDropdownContainer": `AssessmentBlock_sessionDropdownContainer__XMJdh`,
	"mainLayoutWithTask": `AssessmentBlock_mainLayoutWithTask__c3I28`,
	"mainLayoutWithTaskTitle": `AssessmentBlock_mainLayoutWithTaskTitle__iaG4f`,
	"mainLayoutWithTaskName": `AssessmentBlock_mainLayoutWithTaskName__lTci8`,
	"mainLayoutWithTaskStaff": `AssessmentBlock_mainLayoutWithTaskStaff__N8+rr`,
	"mainLayoutWithDue": `AssessmentBlock_mainLayoutWithDue__yRrEd`,
	"mainLayoutWithTaskComplete": `AssessmentBlock_mainLayoutWithTaskComplete__obYgn`,
	"taskTitle": `AssessmentBlock_taskTitle__wgneV`,
	"taskValue": `AssessmentBlock_taskValue__8VMqY`,
	"assessmentInformationPanel": `AssessmentBlock_assessmentInformationPanel__UyDzQ`,
	"assessmentInformation": `AssessmentBlock_assessmentInformation__q4hs9`
};
export default ___CSS_LOADER_EXPORT___;
